import CentricDispatcher from '../dispatcher/CentricDispatcher.react';
import { ActionTypes } from '../constants/CentricConstants';
import { EventEmitter } from 'events';
import assign from 'object-assign';

const CHANGE_EVENT = 'change';

let _entities = [];
let _statusOptions = [];
let _typeOptions = [];
let _fetchedAll = false;
let errors = {};

const findEvent = (id) => (e) => (e !== undefined && e.id === id);
const sanitise = ({id, trainerId, timeStart, timeEnd, ...rest}) => ({
    id: Number(id),
    trainerId: Number(trainerId) || null,
    timeStart: timeStart.slice(0, 19),
    timeEnd: timeEnd.slice(0, 19),
    ...rest,
    canEdit: !!Number(rest.canEdit)
});

const EventStore = assign({}, EventEmitter.prototype, {

    emitChange: function(event = CHANGE_EVENT) {
        this.emit(event);
    },
    addListener: function(callback) {
        this.addChangeListener(callback);
        return { remove: () => this.removeChangeListener(callback) };
    },
    addChangeListener: function(callback, event = CHANGE_EVENT) {
        this.on(event, callback);
    },
    removeChangeListener: function(callback, event = CHANGE_EVENT) {
        this.removeListener(event, callback);
    },

    getStatusOptions: function() {
        return _statusOptions;
    },
    getTypeOptions: function() {
        return _typeOptions;
    },
    getAll: function() {
        return _entities;
    },
    getById: function(id) {
        if (!!errors[id]) { throw {...errors[id]}; }
        return _entities.find(findEvent(id));
    },
    getAvailable: () => _entities.filter((e) => e !== undefined && !!e.available),
    getTrainerEvents: () => _entities.filter(({trainerId}) => !!trainerId),
    getByType: function(type) {
        return _entities.filter((e) => (e !== undefined && e.type === type));
    },
    getByDateRange: (start, end) => {
        if (!start && !end) { return _entities; } //guard
        start = !!start ? Date.parse(start) : null;
        end = !!end ? Date.parse(end) : null;

        return _entities.filter((e) => {
            let condition = e !== undefined && e.type === 'event';
            if (!!start) {
                condition = condition && start <= Date.parse(e.timeStart);
            }
            if (!!end) {
                condition = condition && Date.parse(e.timeEnd) <= end;
            }
            return condition;
        });
    },
    add: function(entity) {
        entity = sanitise(entity);
        const index = _entities.findIndex(findEvent(entity.id));
        EventStore.clearError(entity.id);
        if (0 <= index) {
            _entities[index] = entity;
        } else {
            _entities.push(entity);
        }
    },
    delete: (id) => {
        if (id !== undefined) {
            const index = _entities.findIndex(findEvent(Number(id)));
            if (0 <= index) {
                delete _entities[index];
            }
        }
    },
    addError: (eventId, {code, message, data}) => {
        errors = {
            ...errors,
            [eventId]: {code, message: message || data}
        };
    },
    clearError: (eventId) => delete errors[eventId],
    fetchedAll: () => (_fetchedAll)

});

EventStore.dispatchToken = CentricDispatcher.register(function(action) {
    switch(action.type) {

        case ActionTypes.EVENT_LIST:
            if (action.data.length === 0) {
                _fetchedAll = true;
            } else {
                _fetchedAll = false;
                action.data.forEach(EventStore.add);
            }
            EventStore.emitChange();
            break;

        case ActionTypes.EVENT_LIST_ERROR:
            EventStore.emitChange();
            break;

        case ActionTypes.EVENT_INFO:
            EventStore.add(action.data);
            EventStore.emitChange();
            break;

        case ActionTypes.EVENT_INFO_ERROR:
            EventStore.addError(action.payload.eventId, action);
            EventStore.emitChange();
            break;

        case ActionTypes.EVENT_SAVE:
            EventStore.add(action.data);
            EventStore.emitChange();
            break;

        case ActionTypes.EVENT_UPDATE:
            EventStore.add(action.data);
            EventStore.emitChange();
            break;

        case ActionTypes.EVENT_DELETE:
            EventStore.delete(action.payload.id);
            EventStore.emitChange();
            break;

        case ActionTypes.EVENT_STATUS_OPTION_LIST:
            _statusOptions = action.data;
            EventStore.emitChange();
            break;

        case ActionTypes.EVENT_TYPE_OPTION_LIST:
            _typeOptions = action.data;
            EventStore.emitChange();
            break;

        default:
            break;

    }

});

export default EventStore;
